<template>
	<div class="page">
        <iframe :src="url" name="KuJiaLe" ref="KuJiaLe" id="KuJiaLe" :style="contentStyle"></iframe>
    </div>
</template>

<script>
import request from '@/api/request_d'
import tool from '@/tool'
export default {
	name: 'KuJiaLe',
    props:{},
    components:{},
    data(){
        return{
            url:"",
        }
    },
    computed:{
        user(){
            return this.$store.state.userInfo;
        },
		windowWidth(){
			return this.$store.state.windowWidth;
		},
		windowHeight(){
			return this.$store.state.windowHeight;
		},
        contentStyle(){
			return `width: ${(this.windowWidth-10)}px;height: ${(this.windowHeight-60)}px;overflow: auto;`
        },
        path(){
            return this.$route.path
        }
    },
    watch:{
        path(newVal){
            // console.log(newVal);
            if (newVal == '/KuJiaLe'){
                if (this.$route.query && this.$route.query.type){
                    switch (this.$route.query.type) {
                        case "AuditDesign":
                            if (this.$store.state.auditDesignUrl != null){
                                this.url = this.$store.state.auditDesignUrl;
                                console.log(this.url);
                                this.$store.commit("setAuditDesignUrl", null )
                            }
                            break;
                        case "NewDesign":
                            this.url = '';
                            this.$store.commit("setAuditDesignUrl", null )
                            this.getUrl();
                            break;
                        default:
                            break;
                    }
                } else {
                    if (!this.url){
                        this.getUrl();
                    }
                }
            }
        }
    },
    created(){

    },
    mounted(){
        this.iframeWin = this.$refs['KuJiaLe'].contentWindow;
        this.$nextTick(() => {
            // 在外部 Vue 的 window 上添加 postMessage 的监听，并且绑定处理函数 handleMessage
            window.addEventListener('message', this.onIframeMessage)
        });
    },
    destroyed () {
        // 注意移除监听！注意移除监听！注意移除监听！
        window.removeEventListener('message', this.onIframeMessage);
    },
    methods:{
        getUrl(){
            var that = this;
            // console.log('kjl');   
            if (this.url && this.url != ""){
                return;
            }
            request({
                url:'KJL/NewDesign',
                method:'GET',
                params:{
                    designerId:this.user.ID,
                }
            }).then(({res,headers}) => {
                // console.log(res);
                if (res.stateCode == 200){
                    that.url = res.data + '&launchMiniapp=3FO4K4WIVTPL'
                    console.log(that.url);
                } else {
                    this.$message.error(this.$t(res.errMsg, res.errMsgEn))
                }
            }).catch( err => {
                console.log(err);
                this.$message.error(err.message)
            }).finally(() =>{
                // that.isTableLoading=false;
            })
        },
        onIframeMessage (event) {
            // 根据上面制定的结构来解析 iframe 内部发回来的数据
            // console.error(event);
            var data = null;
            try {
                data = JSON.parse(event.data);
            } catch (error) {
                data = event.data
            }
            // console.log(data);
            // console.error(data.action);
            if (data.action){
                switch (data.action) {
                    //撤回审核
                    case "kjl_desWithdraw":
                        this.ChangeOrderState(data.orderId,-1);
                        break;
                    //审核单提审成功
                    case "kjl_desApplied":
                    //审核单重新审核
                    case "kjl_audReaudit":
                        this.ChangeOrderState(data.orderId,2);
                        break;
                    //作废审核单
                    case "kjl_desDelete":
                        this.ChangeOrderState(data.orderId,-4);
                        break;

                    case "kjl_toggle_leftSideNavigatorTab":
                        // console.error("kjl_loaded");
                        var that = this;
                        setTimeout(()=>{
                            that.openMiniProgram('3FO4K4WIVTPL')
                        }, 5000);
                        break;

                    default:
                        break;
                }
            }
        },
        ChangeOrderState(id,state){
            // 交给酷家乐信息处理
            // var that=this;
            // var postdata={
            //     KjlAuditOrderId:id,
            //     CrmState:state
            // }
            // var timeStamp = this.$store.state.curTime;
            // var token = this.$store.state.tokens[timeStamp];
            // var text = tool.AES_ECB_ENCRYPT(JSON.stringify(postdata),token)
            // request({
            //     url:'CrmOrder/ChangeOrderState',
            //     method:'POST',
            //     params:{
            //         ts:timeStamp,
            //         designerId:this.user.ID,
            //     },
            //     data:{
            //         ciphertext: text
            //     }
            // }).then(({res,headers}) => {
            // }).catch( err => {
            //     console.log(err);
            //     this.$message.error(err.message)
            // }).finally(() =>{
            //     // that.isTableLoading=false;
            // })
        },
        openMiniProgram(id){
            var message = {
                ype: 'START_MINIAPP', 
                id: id
            }
            var iframeWindow = document.getElementById('KuJiaLe').contentWindow;
            console.error(1);
            iframeWindow.postMessage(JSON.stringify(message), '*');
        }
    },
}
</script>

<style scoped>

</style>

<style>

</style>
